export default __webpack_public_path__ + "static/media/q7_step2.6ab8b95c.png";